import PlansList from "./list";

interface Props {
  plansList?: any;
  totalList?: any;
  loadMore?: any;
  suggested?: boolean;
  pageName?: any;
}

function Plans(props: Props) {
  const { plansList, totalList, loadMore, suggested = false, pageName } = props;

  return (
    <>
      <PlansList
        pageName={pageName}
        suggested={suggested}
        plansList={plansList}
        totalList={totalList}
        loadMore={loadMore}
      ></PlansList>
    </>
  );
}

export default Plans;
